import { TranslatedString } from 'lemunzo-api';
import { ConstantsService } from '../../services/constants.service';
import {
    AddedElementModel,
    AddedElementVisibility,
    ElementType,
} from './added-element-model';

export class TextareaElementModel extends AddedElementModel {
    placeholder: TranslatedString;
    minlength: number | undefined;
    maxlength: number | undefined;
    rows: number;

    constructor(
        name: TranslatedString,
        label: TranslatedString,
        placeholder: TranslatedString,
        required: boolean = false,
        visible: AddedElementVisibility = AddedElementVisibility.AlwaysEditable,
        deletable: boolean = true,
        defaultElement: boolean = false,
        minlength: number | undefined = undefined,
        maxlength: number | undefined = undefined,
        rows: number = ConstantsService.TEXTAREA_ROWS_DEFAULT
    ) {
        super(
            ElementType.Textarea,
            name,
            label,
            required,
            visible,
            deletable,
            defaultElement
        );
        this.placeholder = placeholder;
        this.minlength = minlength;
        this.maxlength = maxlength;
        this.rows = rows;
    }
}
